import { graphql } from "~/gql";

export const DATA_IMPORT_SCHEMA_QUERY = graphql(/* GraphQL */ `
  query DataImportSchema($type: VpdDataImportType!) {
    dataImportSchema(type: $type) {
      properties {
        name
        type
        minLength
        maxLength
        default
        format
        required
      }
    }
  }
`);
